<template>
  <div class="center examplex">
    <Header class="layout-header">
      <Row type="flex" align="middle" justify="space-between">
        <div class="flex">
          <img src="@/assets/img/icon_search.png" alt />
          <span class="head-title">{{ $t('global.text16') }}</span>
          <div @click="onSwitchTeam" class="team-select">
            {{ team.name }}
            <img class="icon-down" src="@/assets/img/icon_down.png" alt />
          </div>
        </div>
        <Row type="flex" align="middle">
          <LanguageSwitch class="language-switch-dropdown">
            <img src="@/assets/img/language.svg" alt />
          </LanguageSwitch>

          <Dropdown>
            <div
              class="flex"
              style="cursor: pointer"
              v-if="self && self.employeeWorkInfo"
            >
              <Avatar
                :size="32"
                v-if="self.avatar"
                :src="self.avatar"
                circle
              ></Avatar>
              <Avatar
                :size="32"
                v-else
                style="color: #fff; background-color: rgb(186, 217, 255)"
              >
                {{ $substrName(self.employeeWorkInfo.displayName) }}
              </Avatar>
              <span class="displayName">
                {{ self.employeeWorkInfo.displayName }}
              </span>
            </div>
            <DropdownMenu slot="list">
              <DropdownItem>
                <a :href="accountUrl" class="c-3c-text" target="_blank">
                  {{ $t('global.text5') }}
                </a>
              </DropdownItem>
              <DropdownItem @click.native="loginOut" divided>
                {{ $t('global.text6') }}
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Row>
      </Row>
    </Header>

    <div id="scroll-content" class="square">
      <router-view></router-view>
    </div>

    <SwitchTeamModal ref="switchTeamModalRef" />
    <SubscribeModal />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { AuthManage } from '@/plugins/auth';
import SubscribeModal from '@/components/subscribe-modal';
import { localeKeyToValueMap } from '@/assets/js/multilingual-tools';
import LanguageSwitch from '@/components/LanguageSwitch.vue';
import SwitchTeamModal from '@/components/SwitchTeamModal.vue';
export default {
  data: () => ({
    active: 'guide',
    value1: 'guide',
    teamId: null,
    option: true
  }),
  components: {
    LanguageSwitch,
    SwitchTeamModal,
    SubscribeModal
  },
  computed: {
    ...mapState(['team', 'self', 'selectTeam']),
    accountUrl() {
      return `${process.env.VUE_APP_MAIN_PASS_URL}/auth/realms/yoov/account/`;
    }
  },
  watch: {
    $route(newVal) {
      if (newVal.path !== '/dashboard') {
        this.$nextTick(() => {
          const content = document.getElementById('scroll-content');
          if (content.scrollTop) {
            content.scrollTop = 0;
          }
        });
      }
    },
    selectTeam(newVal) {
      if (newVal) {
        this.onSwitchTeam();
        this.$store.commit('selectTeamChange', false);
      }
    }
  },
  created() {
    this.getCurTeam();
  },
  mounted() {
    const query = _.cloneDeep(this.$route.query);
    if (query.teamId || query.tenant) {
      if (query.teamId) {
        this.teamId = query.teamId;
        delete query.teamId;
      } else if (query.tenant) {
        this.teamId = query.tenant;
        delete query.tenant;
      }
      this.$router.replace({ query });
    } else {
      this.teamId = this.team.id;
    }
  },
  methods: {
    ...mapMutations({
      set_team: 'set_team',
      setSpecialTips: 'setSpecialTips'
    }),
    onSwitchTeam() {
      this.$refs.switchTeamModalRef.show();
    },
    async getCurTeam() {
      let params = {
        size: 1,
        page: 0
      };
      const teamId = localStorage.getItem('teamId');
      if (teamId) {
        params = {
          teamId
        };
      }
      const res = await this.$http('get', 't/teams', params, true);
      const content = res.data.content;
      if (content.length) {
        if (!teamId) {
          localStorage.setItem('teamId', content[0].id);
        }
        this.set_team(content[0]);
        this.getSubscriptionInfo();
      } else {
        if (teamId) {
          localStorage.removeItem('teamId');
        }
      }
    },
    async getSubscriptionInfo() {
      const res = await this.$http(
        'get',
        't/teams/subscription_info',
        {},
        true
      );
      if (res.data.type === 'SPECIAL_VERSION') {
        this.setSpecialTips(true);
      }
    },
    async loginOut() {
      AuthManage.logoutFn();
    },
    async changLang(key) {
      localStorage.setItem('i18n', key);
      this.$i18n.locale = key;
      document.body.className =
        this.$i18n.locale === 'en' ? 'en-font' : 'hk-font';

      window.localStorage.setItem('switchLanguage', true);
      await this.$http(
        'post',
        'mobile/user_language',
        { language: localeKeyToValueMap[key] },
        false
      );
      setTimeout(() => {
        location.reload();
      }, 100);
    }
  }
};
</script>
<style lang="less" scoped>
.layout-header {
  position: fixed;
  top: 0;
  background: #00a4a6;
  width: 100%;
  z-index: 1000;
  padding: 0 36px;

  .head-title {
    margin-left: 8px;
    color: #fff;
    font-size: 24px;
    font-weight: 500;
  }

  .full-name {
    font-size: 16px;
    margin-left: 10px;
  }
}

.language-switch-dropdown {
  margin-right: 20px;

  /deep/.ivu-dropdown-rel {
    display: flex;
  }
}

.c-3c-text {
  color: #3c3c3c;
}

.flex {
  display: flex;
  align-items: center;

  .displayName {
    color: #fff;
    margin-left: 10px;
  }
}

.gary-text {
  color: #9099a6;
}

.team-list {
  padding: 10px 0;
  box-shadow: 0px 1px 0px 0px #dee0e3;

  .team-name {
    margin-left: 16px;
    font-size: 16px;
    font-weight: 400;
    color: #1f2329;
    line-height: 22px;
    max-width: 360px;
    margin-right: 20px;
    text-align: left;
  }
}

.not-margin {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #1f2329;
  padding: 10px 10px 0;
}

#scroll-content {
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  height: 100vh;
  padding-top: 64px;
  padding-bottom: 24px;
}

.team-select {
  padding: 6px 20px;
  cursor: pointer;
  width: initial;
  color: #fff;
  font-size: 14px;
  border-radius: 20px;
  display: flex;
  margin-left: 50px;
  height: 36px;
  border: 1px solid rgba(#ffffff, 0.49);
  align-items: center;

  .icon-down {
    margin-left: 8px;
  }
}

.team-select:hover {
  opacity: 0.49;
}
</style>
